'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["highlights", "size", "spacing", "useTrellisSmileys"];
import { PureComponent } from 'react';
import CsatHappy from './CsatHappy';
import CsatNeutral from './CsatNeutral';
import CsatSad from './CsatSad';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RatingComponents = [CsatSad, CsatNeutral, CsatHappy];
const TRELLIS_IMAGES = ['https://static.hsappstatic.net/feedback-email-assets/ex/img/csat-detractor-trellis.png', 'https://static.hsappstatic.net/feedback-email-assets/ex/img/csat-passive-trellis.png', 'https://static.hsappstatic.net/feedback-email-assets/ex/img/csat-promoter-trellis.png'];
const TRELLIS_LABELS = ['Unhappy', 'Neutral', 'Happy'];
class CsatRating extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      value: undefined
    };
    this.getValue = () => {
      const {
        value: pValue
      } = this.props;
      const {
        value: sValue
      } = this.state;
      // can't short circuit w/ or b/c 0 is valid and falsy
      return pValue === undefined ? sValue : pValue;
    };
    this.handleSelect = rating => () => {
      const {
        onChange
      } = this.props;
      const previous = this.getValue();
      this.setState({
        value: rating
      });
      if (onChange && rating !== previous) {
        onChange(rating);
      }
    };
    this.renderRatingIcon = value => {
      const _this$props = this.props,
        {
          highlights,
          size,
          spacing,
          useTrellisSmileys
        } = _this$props,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded);
      const selected = this.getValue() === value;
      if (useTrellisSmileys) {
        const borderWidth = highlights ? Math.ceil(0.09 * size) : 0;
        return /*#__PURE__*/_jsx("span", Object.assign({
          style: {
            borderLeft: `${value === 0 ? 0 : spacing}px solid transparent`,
            display: 'inline-block',
            lineHeight: 0
          }
        }, props, {
          children: /*#__PURE__*/_jsx("span", {
            "data-selenium-test": `rating-${value}`,
            onClick: this.handleSelect(value),
            role: "button",
            tabIndex: 0,
            "aria-label": TRELLIS_LABELS[value],
            style: {
              cursor: 'pointer',
              display: 'inline-block',
              borderRadius: '50%',
              borderStyle: 'solid',
              borderWidth: `${borderWidth}px`,
              borderColor: selected ? '#33475B' : 'transparent',
              padding: `${borderWidth}px`,
              transition: 'border-color linear 0.2s'
            },
            children: /*#__PURE__*/_jsx("img", {
              src: TRELLIS_IMAGES[value],
              alt: TRELLIS_LABELS[value],
              width: size - borderWidth * 2,
              height: size - borderWidth * 2,
              style: {
                display: 'block',
                borderRadius: '50%'
              }
            })
          })
        }));
      }
      const RatingComponent = RatingComponents[value];
      return /*#__PURE__*/_jsx("span", Object.assign({
        style: {
          borderLeft: `${value === 0 ? 0 : spacing}px solid transparent`,
          display: 'inline-block',
          lineHeight: 0
        }
      }, props, {
        children: /*#__PURE__*/_jsx(RatingComponent, {
          "data-selenium-test": `rating-${value}`,
          highlights: highlights,
          onClick: this.handleSelect(value),
          selected: selected,
          size: size,
          useTrellisSmileys: useTrellisSmileys
        })
      }));
    };
    this.render = () => /*#__PURE__*/_jsxs("div", {
      "data-selenium-test": "feedback-rating-csat",
      "data-test-id": "feedback-rating-csat",
      style: {
        display: 'inline-block'
      },
      children: [this.renderRatingIcon(0), this.renderRatingIcon(1), this.renderRatingIcon(2)]
    });
  }
}
CsatRating.defaultProps = {
  highlights: true,
  size: 60,
  spacing: 0,
  useTrellisSmileys: false
};
export default CsatRating;